<app-toolbar></app-toolbar>

<div class="gdl-container">
  <h1>ECS Software Engineering Projects</h1>
  <h2>ECS Software Engineering Projects</h2>

  <app-tabla [ec2Repositories]="demo"></app-tabla>
</div>
